module.exports = __webpack_public_path__ + "static/media/BTFG.c6dbab9f.png";